export default __webpack_public_path__ + "static/media/logo-color.30ae1de1.svg";